import { MERGE_TAG_REPLACED_VALUE_PREFIX } from "../merge-tags/merge-tags-constants";
import { parseMergeTagOptions } from "../merge-tags/merge-tags.utils";
import {
  decorateWildcardTokensInHtml,
  isWildcardTag
} from "../merge-tags/replace-wildcards.utils";
import { getHtmlLikeText } from "../word-processor-value.utils";

export const getTextWithMergeTagsValues = (params: {
  text: string;
  getMergeTagValue?: (
    mergeTag: string,
    options?: Record<string, any>
  ) => string | undefined | null;
  replaceMergeTagName?: (mergeTag: string) => string;
  insertMergeTagValues?: boolean;
  allowHtml?: boolean;
}) => {
  const {
    text,
    getMergeTagValue,
    replaceMergeTagName,
    insertMergeTagValues,
    allowHtml
  } = params;
  let result = text;
  if (
    getMergeTagValue &&
    result &&
    result.indexOf("{{") >= 0 &&
    result.indexOf("}}") >= 0
  ) {
    let match: any = null;
    const mergeTagsRegexp = /{{(.*?)}}/g;
    const foundTagMatches = new Set<string>();
    while ((match = mergeTagsRegexp.exec(result)) !== null) {
      if (match.index === mergeTagsRegexp.lastIndex) {
        mergeTagsRegexp.lastIndex++;
      }
      foundTagMatches.add(match[0]);
    }
    if (insertMergeTagValues) {
      foundTagMatches.forEach((mergeTag) => {
        // Replace wildcards are never bound to data — leave the literal token
        // untouched so it survives into the editor to be highlighted/filled in.
        if (isWildcardTag(mergeTag)) return;
        const { options } = parseMergeTagOptions(mergeTag);
        result = result.replaceAll(
          mergeTag,
          `${MERGE_TAG_REPLACED_VALUE_PREFIX}${
            getMergeTagValue(mergeTag, options) ?? ""
          }`
        );
      });
    } else if (replaceMergeTagName) {
      foundTagMatches.forEach((mergeTag) => {
        if (isWildcardTag(mergeTag)) return;
        result = result.replaceAll(
          mergeTag,
          `${MERGE_TAG_REPLACED_VALUE_PREFIX}${
            replaceMergeTagName(mergeTag) ?? ""
          }`
        );
      });
    }
    if (!allowHtml) {
      result = getHtmlLikeText(result);
    }
  }

  if (allowHtml) {
    result = decorateWildcardTokensInHtml(result);
  }

  return result;
};
